import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { getProducerBySlug } from "../api/producerApi";
import { loginUser } from "../api/authApi";

function LoginPage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [producer, setProducer] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (slug) {
      getProducerBySlug(slug)
        .then((res) => {
          console.log(res.data);
          setProducer(res.data);
          localStorage.setItem(
            "producerData",
            JSON.stringify({
              producer: res.data,
            }))
  
        })
        .catch((err) => {
          console.error("Error fetching producer:", err);
          setProducer(null);
        });
    }
  }, [slug]);

  const handleLogin = () => {
    loginUser(slug, {
      username,
      password,
      producerId: producer ? producer.id : null,
    })
      .then((res) => {
        console.log(res);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem(
          "productData",
          JSON.stringify({
            products: res.data,
          })
        );
        navigate("/dashboard");
      })
      .catch(() => alert("Invalid login"));
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-gray-50 to-gray-200 p-4">
      
      {/* Logo Section */}
      <div className="flex flex-col items-center mb-6">
        {producer?.logo ? (
          <img
            src={producer.logo}
            alt={`${producer.name} Logo`}
            className="w-40 h-40 object-contain rounded-full border border-gray-300 shadow-sm mb-4 bg-white"
          />
        ) : (
          <div className="w-40 h-40 flex items-center justify-center bg-gray-200 rounded-full mb-4 text-gray-500 text-sm">
            Logo
          </div>
        )}
        <h2 className="text-2xl font-semibold text-gray-800">
          {producer ? `Welcome to ${producer.name}` : "Welcome"}
        </h2>
      </div>

      {/* Login Box */}
      <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-sm">
        <input
          className="border w-full px-3 py-2 mb-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Username"
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          className="border w-full px-3 py-2 mb-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          type="password"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          onClick={handleLogin}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg font-semibold transition duration-200"
        >
          Login
        </button>

        {/* Extra Links */}
        <div className="flex justify-between items-center mt-4 text-sm text-blue-600">
          <Link
            to="/forgot-password"
            className="hover:underline hover:text-blue-700 transition"
          >
            Forgot Password?
          </Link>
          <Link
            to="/signup"
            className="hover:underline hover:text-blue-700 transition"
          >
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
